import { api } from '../lib/api'

export type GiftCatalogItemDTO = {
  id: string
  emoji: string
  name: string
  default_amount_cents: number
  is_age_restricted?: boolean
}

export async function getGiftCatalog(): Promise<GiftCatalogItemDTO[]> {
  const { data } = await api.get('/api/gifts/catalog/')
  if (Array.isArray(data)) return data as GiftCatalogItemDTO[]
  if (Array.isArray((data as any)?.items)) return (data as any).items as GiftCatalogItemDTO[]
  return []
}

export type SendGiftRequest = {
  gift_id: string
  custom_amount_cents?: number
  note?: string
  anon?: boolean
  idempotency_key: string
}

export type SendGiftResponse = {
  ok: boolean
  gift_event_id?: number
  target_type?: 'post' | 'comment' | 'profile'
  post_id: number | null
  recipient_user_id?: number | null
  recipient?: {
    user_id: number
    handle: string
    display_name: string
    avatar_url: string
  } | null
  gift: { id: string; emoji: string; name: string }
  amount_cents: number
  amount_pixe?: number
  note?: string | null
  anon?: boolean
  ledger_entry_id?: number | null
  created_at?: string
  totals?: { tips?: number }
}

export async function sendGift(postId: number | string, payload: SendGiftRequest): Promise<SendGiftResponse> {
  const { data } = await api.post(`/api/gifts/posts/${postId}/gift/`, payload)
  return data
}

export async function sendCommentGift(commentId: number | string, payload: SendGiftRequest): Promise<SendGiftResponse> {
  const { data } = await api.post(`/api/gifts/comments/${commentId}/gift/`, payload)
  return data
}

export async function sendProfileGift(publicId: string, payload: SendGiftRequest): Promise<SendGiftResponse> {
  const { data } = await api.post(`/api/gifts/people/${publicId}/gift/`, payload)
  return data
}

export async function sendPeopleUserGift(userId: number, payload: SendGiftRequest): Promise<SendGiftResponse> {
  const { data } = await api.post(`/api/people/${userId}/gift/`, payload)
  return data
}
